"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.partiallyUpdateComponents = void 0;
const components_1 = require("@/store/ducks/components");
const components_2 = require("@/services/components");
function partiallyUpdateComponents(components) {
    return async (dispatch) => {
        const partiallyUpdateComponentsPromises = components.map((component) => (0, components_2.partialUpdateComponent)(component?.id, {
            order: component.order,
        }));
        dispatch((0, components_1.saveChanges)());
        try {
            const responses = await Promise.allSettled(partiallyUpdateComponentsPromises);
            if (responses.some((response) => response.status === "rejected")) {
                dispatch((0, components_1.saveChangesError)());
                dispatch((0, components_1.openComponentToast)());
                return;
            }
            dispatch((0, components_1.saveChangesSuccess)());
            dispatch((0, components_1.openComponentToast)());
        }
        catch (error) {
            dispatch((0, components_1.saveChangesError)());
            dispatch((0, components_1.openComponentToast)());
        }
    };
}
exports.partiallyUpdateComponents = partiallyUpdateComponents;
